<app-header-style-two></app-header-style-two>
<div class="page-title-area page-title-style-two">
    <div class="container">
        <div class="page-title-content" style="text-align: left;">
            <h1 class="mb-3">Contact Us</h1>
            <ul class="text-background">
                <li>Contact</li>
                <li><a routerLink="/">Home</a></li>
            </ul>
        </div>
    </div>
</div>


<div class="contact-area pb-100 pt-100">
    <div class="container">
        <div class="contact-form">
            <form [formGroup]="formGroup">
                <div class="row">
                    <div class="col-4 col-md-4">
                        <div class="form-group">
                            <input class="form-control"  style="color: black !important;" formControlName="name" type="text"
                                placeholder="{{'MENU.Name' | translate}}">
                            <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                                {{"MENU.Required" |
                                translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-4 col-md-4">
                        <div class="form-group">
                            <input class="form-control"   style="color: black !important;"formControlName="phone" type="number"
                                placeholder="{{'MENU.Phone' | translate}}">
                            <div class="invalid-feedback" *ngIf="controlHasError('required', 'phone')">
                                {{"MENU.Required" |
                                translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-4 col-md-4">
                        <div class="form-group">
                            <input type="email"  style="color: black !important;" formControlName="email" class="form-control"
                                placeholder="{{'MENU.Email' | translate}}" name="subject">
                        </div>
                    </div>
                    <div class="col-12 col-md-12">

                        <div class="form-group">
                            <textarea class="form-control" style="color: black !important;" formControlName="message"
                                name="message"></textarea>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12" style="    text-align: center;  ">
                        <button (click)="create()" type="submit" class="default-btn"><i
                                class='bx bx-paper-plane icon-arrow before'></i><span class="label">{{"MENU.Send" |
                                translate}}</span><i class="bx bx-paper-plane icon-arrow after"></i></button>
                    </div>
                </div>
            </form>

        </div>
    </div>
    <div class="contact-bg-image"><img src="assets/img/map.png" alt="image"></div>
</div>